import { supabase } from "../lib/supabase";
import { SupabaseKnowledgeDocument } from "../types/supabase";
import { BaseApi } from "./baseApi";

class KnowledgeApi extends BaseApi<SupabaseKnowledgeDocument> {
  async uploadDocument(
    document: SupabaseKnowledgeDocument,
    file: File
  ): Promise<string> {
    // Upload source file to supabase storage
    const documentName = document.name;

    const { error: uploadError } = await supabase.storage
      .from("knowledge-documents")
      .upload(documentName, file);

    if (uploadError) {
      console.error(uploadError);
      throw uploadError;
    } else {
      // Upload document record to supabase database
      const { error: uploadedDocumentError } = await supabase
        .from("knowledge_documents")
        .upsert(document);
      if (uploadedDocumentError)
        throw uploadedDocumentError || new Error("Failed to upload document");

      const requestUrl = `${import.meta.env.VITE_BACKEND_BASE_URL}/chunk_document?document_uuid=${document.uuid}`;
      console.log("requestUrl", requestUrl);

      const response = await fetch(requestUrl, {
        method: "POST",
      });

      console.log(response);

      if (!response.ok) {
        throw new Error("Failed to chunk document");
      }

      return "success";
    }
  }

  async getSignedUrl(filePath: string): Promise<string> {
    const { data, error } = await supabase.storage
      .from("knowledge-documents")
      .createSignedUrl(filePath, 3600); // 1 hour expiry

    if (error) throw error;
    return data.signedUrl;
  }

  async getDocuments(): Promise<SupabaseKnowledgeDocument[]> {
    const { data, error } = await supabase
      .from("knowledge_documents")
      .select("*")
      .order("created_at", { ascending: false });
    if (error) throw error;
    return data;
  }

  async getDocumentById(id: string): Promise<SupabaseKnowledgeDocument> {
    const { data, error } = await supabase
      .from("knowledge_documents")
      .select("*")
      .eq("id", id);
    if (error) throw error;
    return data[0];
  }

  async deleteDocumentFromStorage(filePath: string): Promise<void> {
    console.log("Deleting document from storage", filePath);
    const { error } = await supabase.storage
      .from("knowledge-documents")
      .remove([filePath]);

    console.log("Error", error);

    if (error) throw error;
  }
}

export const knowledgeApi = new KnowledgeApi("knowledge_documents");
